import { useQuery } from '@common/hooks';
import { IntakeService } from '@common/services';
import { StringUtility } from '@common/utils';
import { Page } from '@customer/components/layout/.';
import { useCreateIntakePetStore, useCreateIntakeStore } from '@customer/stores/hooks';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { usePromiseTracker } from 'react-promise-tracker';
import { useParams } from 'react-router-dom';
import { IntakePetDetail } from ".";

export const IntakePetContainer = observer(() => {
    const intakeStore = useCreateIntakeStore({ shouldSetContext: false });
    const store = useCreateIntakePetStore(intakeStore, { shouldSetContext: true });
    const { intakepublicid, intakepetid } = useParams();
    const query: URLSearchParams = useQuery();
    const fetchIntake = usePromiseTracker({ delay: 500, area: IntakeService.tags.getIntake });

    useEffect(() => {
        if (intakepublicid) {
            store.load(intakepublicid, query.get('linkSource') || 'email', intakepetid ? +intakepetid : 0);
            // store.intakeStore.setParamValues(intakepublicid, query.get('linkSource') || 'email', intakepetid ? +intakepetid : 0);
        }
    }, [store, intakepetid, intakepublicid, query]);

    return (
        <>
            <Page className="pet-profile">
                <Page.Content>
                    {(!fetchIntake.promiseInProgress) &&
                        <>
                            <Row>
                                <Col xs={12} className="px-3">
                                    <h3>{store.selectedPet ? StringUtility.toPossessiveName(store.selectedPet.name) : "Pet"} information</h3>
                                    <div className="section-container">
                                        {
                                            store.progressSections.map((section, index) => (
                                                <span key={`section_${index}`} className={classNames('section',
                                                    {
                                                        'section-active': index <= store.selectedSectionIndex + 1,
                                                        'section-inactive': index > store.selectedSectionIndex + 1
                                                    }
                                                )} style={{ width: store.sectionWidth + '%' }}>
                                                </span>
                                            ))
                                        }
                                    </div>
                                </Col>
                            </Row>
                            <IntakePetDetail />
                        </>
                    }
                </Page.Content>
            </Page>
        </>
    );
});
